// src/services/dealer.service.js
import api from './api';

const dealerService = {
  getAllDealers: async (companyId, page = 1, limit = 10, search = '') => {
    try {
      const params = { page, limit };
      if (companyId) params.companyId = companyId;
      if (search && search.trim()) params.search = search.trim();

      const response = await api.get('/dealers', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching dealers:', error);
      throw error;
    }
  },

  // Get dealer by ID
  getDealerById: async (id) => {
    try {
      const response = await api.get(`/dealers/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching dealer:', error);
      throw error;
    }
  },

  // Create new dealer
  createDealer: async (dealerData) => {
    try {
      const response = await api.post('/dealers', dealerData);
      return response.data;
    } catch (error) {
      console.error('Error creating dealer:', error);
      throw error;
    }
  },

  // Update dealer
  updateDealer: async (id, dealerData) => {
    try {
      const response = await api.post(`/dealers/${id}`, dealerData);
      return response.data;
    } catch (error) {
      console.error('Error updating dealer:', error);
      throw error;
    }
  },

  // Delete dealer
  deleteDealer: async (id) => {
    try {
      const response = await api.delete(`/dealers/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting dealer:', error);
      throw error;
    }
  },

  // --- NAYA FUNCTION YAHAN ADD KIYA GAYA HAI ---
  approveDealer: async (id) => {
    try {
      const response = await api.post(`/dealers/${id}/approve`);
      return response.data;
    } catch (error) {
      console.error('Error approving dealer:', error);
      throw error;
    }
  },
  // ----------------------------------------------

  // Get dealer count
  getDealerCount: async (companyId = null) => {
    try {
      const params = companyId ? { companyId } : {};
      const response = await api.get('/dealers/count', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching dealer count:', error);
      throw error;
    }
  },
};

export default dealerService;